<template>
	<div
		id="rubric"
		class="white pa-2"
	>
		<interaction-wrapper
			v-for="ri in rubricInteractions"
			:interaction-id="ri.id"
			:key="'i_' + ri.id"
		></interaction-wrapper>
		<v-flex
			xs6
			offset-xs3
			class="text-xs-center"
		>
			<v-btn
				block
				aria-label="Submit Rubric"
				:disabled="(
          !rubricComplete
          || rubricSubmitting
          || !!rubricSubmitted
        )"
				:loading="rubricSubmitting"
				@click="submitRubric(rubricInteractionStates)"
				color="primary"
			>
				{{ !!rubricSubmitted ? 'Submitted' : 'Submit Rubric' }}
			</v-btn>
		</v-flex>
	</div>
</template>


<script>
import InteractionWrapper from '../../interaction/InteractionWrapper';

import _ from 'lodash';
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

/* eslint-disable */
export default {
  name: 'rubric',
  components: {
    InteractionWrapper
  },
  computed: {
    ...mapGetters('interactions', [
      'interactionStates',
      'rubricInteractions',
      'rubricSubmitting',
      'rubricSubmitted',
    ]),
    ...mapGetters('player', [
      'sidebarTab',
      'hasNewInteractionDisplayAccess',
    ]),
    rubricInteractionStates() {
      return _.filter(this.interactionStates, is => is.interaction.config.template_key === 'rubric');
    },
    rubricComplete() {
      return _.filter(this.interactionStates, is => {
        return is.interactionMeta.rubric && is.interactionMeta.isAnswerEmpty
      }).length === 0;
    },
  },
  methods: {
    ...mapActions('interactions', [
      'submitRubric',
    ]),
    ...mapMutations('interactions', [
      'setRubricSubmitted',
      'setInteractionStates',
    ]),
  },
  watch: {
    async 'sidebarTab'(n,o) {
      await this.$nextTick();
      if (n === 'rubric-tab' && this.hasNewInteractionDisplayAccess) this.setInteractionStates();
    },
  },
  mounted() {
    if (this.hasNewInteractionDisplayAccess) this.setInteractionStates();
    if (_.filter(this.interactionStates, is => is.interaction.config.template_key === 'rubric' && !is.interactionMeta.isInteractionAnswered).length === 0) {
      this.setRubricSubmitted(1); // if we imported displayTime this component would have to watch that value and update constantly. 
    }

  },

}
</script>


<style>
    #rubric .interaction {
      height: auto !important;
    }
    .pp-rubric-section-text {
      font-weight: 700;
      border-bottom: 2px solid var(--branding-active-hex);
    }
    .pp-rubric-criteria {
      display: flex;
    }
    .pp-rubric-criteria-text {
      width: 80%;
    }
    .pp-rubric-criteria-input {
      width: 20%;
      display:flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      margin-left: 10px;
    }
    .pp-rubric-criteria-input::after {
      color: var(--branding-active-hex);
      font-size: 11px;
    }
    .out-of-1 .pp-rubric-criteria-input::after {
      content: 'out of 1 points';
    }
    .out-of-2 .pp-rubric-criteria-input::after {
      content: 'out of 2 points';
    }
    .out-of-3 .pp-rubric-criteria-input::after {
      content: 'out of 3 points';
    }
    .out-of-4 .pp-rubric-criteria-input::after {
      content: 'out of 4 points';
    }
    .out-of-5 .pp-rubric-criteria-input::after {
      content: 'out of 5 points';
    }
    .pp-rubric-criteria-input input {
      margin-bottom: 0 !important;
      width: 72px !important;
    }
    .pp-rubric-criteria-input input::-webkit-input-placeholder {
       text-align: left;
    }
</style>
